import { new__cn as cn } from '../util';

export const style = {
  languageSwitch(visible: boolean) {
    return cn(
      'h-10 w-fit rounded-md px-2 py-1 text-body-m font-bold',
      'hover:shadow-sm',
      {
        'bg-white text-gray-500': !visible,
        'bg-tertiary-200 text-secondary-300': visible,
      },
    );
  },

  icon: 'size-4',
};
